import { render } from "./ShapePool.vue?vue&type=template&id=f3479f82&scoped=true&ts=true"
import script from "./ShapePool.vue?vue&type=script&lang=ts"
export * from "./ShapePool.vue?vue&type=script&lang=ts"

import "./ShapePool.vue?vue&type=style&index=0&id=f3479f82&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3479f82"]])

export default __exports__